module.exports = __webpack_public_path__ + "static/media/coqui.44d784a5.svg";